import { render, staticRenderFns } from "./MaterialCategoryManagement.vue?vue&type=template&id=7803ebe2&scoped=true"
import script from "./MaterialCategoryManagement.vue?vue&type=script&lang=js"
export * from "./MaterialCategoryManagement.vue?vue&type=script&lang=js"
import style0 from "./MaterialCategoryManagement.vue?vue&type=style&index=0&id=7803ebe2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7803ebe2",
  null
  
)

export default component.exports